import React, { createContext, useContext, useEffect, useState } from 'react';
import { login, register, resetPassword } from '../services/authService';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // 检查本地存储中是否有用户信息
    const storedUser = localStorage.getItem('user');
    const token = localStorage.getItem('token');
    
    if (storedUser && token) {
      setUser(JSON.parse(storedUser));
    }
    
    setLoading(false);
  }, []);

  const handleLogin = async (email, password) => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await login(email, password);
      
      // 保存用户信息和令牌到本地存储
      localStorage.setItem('user', JSON.stringify(response.user));
      localStorage.setItem('token', response.access_token);
      
      setUser(response.user);
      return response;
    } catch (err) {
      setError(err.message || '登录失败');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (email, password) => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await register(email, password);
      return response;
    } catch (err) {
      setError(err.message || '注册失败');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async (oldPassword, newPassword) => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await resetPassword(oldPassword, newPassword);
      return response;
    } catch (err) {
      setError(err.message || '重置密码失败');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    // 清除本地存储和状态
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    setUser(null);
  };

  const handleLoginWithToken = (token, userInfo) => {
    if (!token || !userInfo) return;
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userInfo));
    setUser(userInfo);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        error,
        login: handleLogin,
        loginWithToken: handleLoginWithToken,
        register: handleRegister,
        resetPassword: handleResetPassword,
        logout: handleLogout,
        isAuthenticated: !!user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
